import { request } from '../request'

// 页面级tab数据
export function getPageTabs(data) {
  return request({
    url: '/wjsettlement/center/statement/statementTabInfo',
    method: 'post',
    data
  })
}

// 我审批的列表
export function getMyApproval(params) {
  return request({
    url: '/wjsettlement/center/statement/page/iAudited',
    method: 'get',
    params
  })
}

// 我支付的列表
export function getMyPay(params) {
  return request({
    url: '/wjsettlement/center/statement/page/iPaid',
    method: 'get',
    params
  })
}

// 明细二级列表（全部）
export function getSecondaryDetails(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getSettleDetailListById',
    method: 'get',
    params
  })
}

// 我审批的导出
export function exportMyApproval(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadAudited',
    method: 'post',
    data
  })
}

// 我支付的导出
export function exportMyPay(data) {
  return request({
    url: '/wjsettlement/center/projectExcel/downloadPaid',
    method: 'post',
    data
  })
}

// 流程审批明细
export function getApprovalDetailProcess(statementId = '') {
  return request({
    url: '/wjsettlement/center/statement/getTaskAuditList',
    method: 'get',
    params: {
      statementId
    }
  })
}

// 审批（通过/驳回）
export function toApproval(params) {
  return request({
    url: '/wjsettlement/center/statement/audit',
    method: 'get',
    params
  })
}

// 审批详情
export function getApprovalDetail(taskId = '') {
  return request({
    url: '/wjsettlement/center/statement/getAuditInfo',
    method: 'get',
    params: {
      taskId
    }
  })
}

// 历史审批
export function getHistoryApprovals(statementId = '') {
  return request({
    url: '/wjsettlement/center/statement/getHistoryAuditList',
    method: 'get',
    params: {
      statementId
    }
  })
}

// 根据ID获取企业余额信息
export function getCompanyBalance(id = '') {
  return request({
    url: '/wjsettlement/wjSettleCompany/get',
    method: 'get',
    params: { id }
  })
}

// 批量审批详情查看
export function getBatchApprovalDetail(data) {
  return request({
    url: '/wjsettlement/center/statement/batchAuditInfo',
    method: 'post',
    data
  })
}

// 批量审批
export function toBatchApproval(data) {
  return request({
    url: '/wjsettlement/center/statement/batchAudit',
    method: 'post',
    data
  })
}

// 批量支付
export function toBatchPay(data) {
  return request({
    url: '/wjsettlement/center/statement/batchPayed',
    method: 'post',
    data
  })
}

// 批量支付同类型平台校验
export function vaildBatchSamePlatform(data) {
  return request({
    url: '/wjsettlement/center/statement/checkSettlesPlanCategory',
    method: 'post',
    data
  })
}
